export default __webpack_public_path__ + "cc8d796e4c3b01b4034ead6ed2ecd3fc.png";